<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div class="toolbar-left">
          <el-select v-model="filter.status" clearable placeholder="处理状态" style="width: 130px" @change="getReports">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="filter.target_type" clearable placeholder="举报对象" style="width: 140px" @change="getReports">
            <el-option label="帖子" value="post"></el-option>
            <el-option label="楼层" value="floor"></el-option>
            <el-option label="楼中楼" value="floor_reply"></el-option>
            <el-option label="私聊消息" value="chat_message"></el-option>
            <el-option label="用户" value="user"></el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getReports">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetFilter">重置</el-button>
        </div>
        <div class="toolbar-count">共 {{ list.length }} 条举报</div>
      </div>

      <el-table :data="list" height="76vh" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column label="举报人" min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.nickname || "未知用户" }}</div>
            <div class="muted">UID：{{ scope.row.uid }} · {{ scope.row.email || "-" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="对象" width="150">
          <template slot-scope="scope">
            <el-tag>{{ targetLabel(scope.row.target_type) }}</el-tag>
            <span class="target-id">#{{ scope.row.target_id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="原因" min-width="160"></el-table-column>
        <el-table-column prop="detail" label="补充说明" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openHandle(scope.row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="处理举报" :visible.sync="visible" width="520px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="举报对象">
          <div>{{ targetLabel(form.target_type) }} #{{ form.target_id }}</div>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理备注">
          <el-input type="textarea" v-model="form.admin_note" :rows="5" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess, optionLabel, optionType, reportStatusOptions } from "./appAdminUtils.js";

export default {
  name: "forumReports",
  data() {
    return {
      statusOptions: reportStatusOptions,
      filter: {
        status: "",
        target_type: "",
      },
      list: [],
      visible: false,
      form: {},
      targetMap: {
        post: "帖子",
        floor: "楼层",
        floor_reply: "楼中楼",
        chat_message: "私聊消息",
        user: "用户",
      },
    };
  },
  mounted() {
    this.getReports();
  },
  methods: {
    formatTime,
    statusLabel(value) {
      return optionLabel(reportStatusOptions, value);
    },
    statusType(value) {
      return optionType(reportStatusOptions, value);
    },
    targetLabel(value) {
      return this.targetMap[value] || value || "-";
    },
    getReports() {
      post("/api/admin/app/reports", this.filter).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "举报列表获取失败");
        }
      });
    },
    resetFilter() {
      this.filter = {
        status: "",
        target_type: "",
      };
      this.getReports();
    },
    openHandle(row) {
      this.form = {
        id: row.id,
        target_type: row.target_type,
        target_id: row.target_id,
        status: row.status || "pending",
        admin_note: row.admin_note || "",
      };
      this.visible = true;
    },
    submitHandle() {
      post("/api/admin/app/updatereport", {
        id: this.form.id,
        status: this.form.status,
        admin_note: this.form.admin_note || "",
      }).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.visible = false;
          this.getReports();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.toolbar-count,
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.target-id {
  margin-left: 8px;
  color: #606266;
}
</style>
